module.exports = require("./lib/api/register/node-polyfill");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/register.js
 ** module id = 516
 ** module chunks = 0
 **/